import React from "react";
import HeaderComponent from "../HelloTrade/HeaderComponent";
import "../../CssFiles/lenderPartner.css";
import FooterComponent from "../HelloTrade/FooterComponent";
import fast_approval_banner from "../../Images/benefitImages/fast_approval_banner_desktop-min.png";
import fast_approval_banner_msite from "../../Images/benefitImages/fast_approval_banner_msite.png";
import FlexiLoans from '../../Images/lenderImages/FlexiLoans.jpg'

export function LenderPartnerComponent() {
  return (
    <div id="lender-partner">
      <HeaderComponent />

      <div style={{ textAlign: "center" }}>
        <img
          src={fast_approval_banner}
          alt="fast-approval-banner"
          className="fastBanner desktopBanner"
        />
        <img
          src={fast_approval_banner_msite}
          alt="fast-approval-banner"
          className="fastBanner mobileBanner"
        />
      </div>

      <div className="title">Our Lending Partners</div>

      <div className="lenderBox">
        <div className="lenderName">FlexiLoans <img src={FlexiLoans} alt="flexi-logo" style={{width:'60px'}}/> </div>
        <div>
          Grievance Redressal Mechanism :{" "}
          <a href="https://flexiloans.com/grievance-redressal-mechanism" target="_blank">
            https://flexiloans.com/grievance-redressal-mechanism
          </a>{" "}
        </div>
        <div>Grievance Redressal Officer Name : Ms. Pranaali Sawant</div>
        <div>Email : Customer can write to FlexiLoans at myaccount@flexiloans.com</div>
        <div>
          Contact Number : Customers can call FlexiLoans on toll free number: 022 -
          68219595 (Telephone Lines are open on 10:00 am to 7:00 pm Monday to
          Saturday except National Holidays)
        </div>
        <div>
          Complaint Portal :{" "}
          <a href="https://flexiloans.com/grievance-redressal-mechanism" target="_blank">
            https://flexiloans.com/grievance-redressal-mechanism
          </a>{" "}
        </div>
        <div>
          Privacy Policy :{" "}
          <a href="https://flexiloans.com/privacy-policy" target="_blank">
            https://flexiloans.com/privacy-policy
          </a>{" "}
        </div>
      </div>

      <FooterComponent />
    </div>
  );
}
